export const SERVER_URL_CATALOGO = process.env.VUE_APP_SERVER_URL_CATALOGO;
export const SERVER_URL_ISTANZE = process.env.VUE_APP_SERVER_URL_ISTANZE;
export const SERVER_URL_ISTANZE_GATEWAY = process.env.VUE_APP_SERVER_URL_ISTANZE + '/gateway';
export const SERVER_URL_REPO = process.env.VUE_APP_SERVER_URL_REPO;
